import React from 'react';

const DependentsBlock = function (props: {children: React.ReactNode}) {
  return (
    <div
      className={
        'flex flex-wrap align-content-start gap-[15px] w-[calc(100%-60px)]'
      }
      {...props}
    />
  );
};

export default DependentsBlock;
